import { render, staticRenderFns } from "./QueryPolicyAmendRetention.vue?vue&type=template&id=c207d4ce&"
import script from "./QueryPolicyAmendRetention.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyAmendRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports